import { PRODUCTION, DEVELOPMENT, LOCAL_COMPLIANCE_URL } from "./const";
import { isEmpty } from "lodash";

export function getComplianceUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const COMPLIANCE_URL = !!process.env.REACT_APP_COMPLIANCE_URL && process.env.REACT_APP_COMPLIANCE_URL !== "" ? process.env.REACT_APP_COMPLIANCE_URL : LOCAL_COMPLIANCE_URL;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_COMPLIANCE_URL;
      case PRODUCTION:
        return COMPLIANCE_URL;
      default:
        return LOCAL_COMPLIANCE_URL;
    }
  } else {
    return LOCAL_COMPLIANCE_URL;
  }
}

export const getComplianceUrlValue = () => {
  return getComplianceUrl();
};
